<template> 
    <div class="bg-white py-20">
      <div class="md:px-10 max-w-screen-4xl mx-auto px-6 lg:px-12">
        <div class="row">
          <div class="col-12 yola-style">
            <div class="card border-none">
              <video 
                src="../assets/video/Lagos.mp4" 
                autoplay 
                muted 
                loop 
                playsinline 
                class="w-full h-auto rounded-lg"
              ></video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {};
  </script>
  
  <style scoped>
  /* You can add styles if needed */
  </style>
  